import { render, staticRenderFns } from "./HistoryOperations.vue?vue&type=template&id=32f3991a"
import script from "./HistoryOperations.vue?vue&type=script&setup=true&lang=ts"
export * from "./HistoryOperations.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./HistoryOperations.vue?vue&type=style&index=0&id=32f3991a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports